import React from 'react';
import { AddSessionFormMobile, AddSessionFormikMobile, Button, AddSessionFormSubmitButton } from '@uplift/ui-v2';
import { Box, Divider } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { TimeRange } from '@uplift/types';


export type SessionDetailsProps = {
  patientId: string;
  eventRange: TimeRange;
  onBack: () => void;
  onSuccess: () => Promise<void>;
};


export const SessionDetails: React.VFC<SessionDetailsProps> = (props) => {
  return (
    <AddSessionFormikMobile
      onClose={props.onBack}
      onSuccess={props.onSuccess}
      newEvent={props.eventRange}
      patientId={props.patientId}
    >
      <Box display="flex" flexDirection="column" height="100%">
        <Box p={1}><Button startIcon={<ArrowBack />} color="secondary" onClick={props.onBack}>Back</Button></Box>
        <AddSessionFormMobile
          open={true}
          showInviteToggle={false}
          showPatientPicker={false}
        />
        <Box flex="1" />
        <Box>
          <Divider />
          <Box p={3}>
            <AddSessionFormSubmitButton color="secondary" variant="contained" fullWidth>
              Schedule session
            </AddSessionFormSubmitButton>
          </Box>
        </Box>
      </Box>
    </AddSessionFormikMobile>
  );
};
